export default function formatCurrency(value) {
  const val = Number(value).toFixed(2)
  return val.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
